<template lang="pug">
#empresa-tabela-inserir-contrato-originacao-ar
    el-table(
        ref='multipleTable',
        :data='contratosNaoEnviados',
        v-loading='carregando',
        @sort-change='ordenarContratos',
        style='width: 100%',
        @selection-change='handleSelectionChange'
    )
        el-table-column(type='selection', width='55')
        el-table-column(
            property='numeroContrato',
            min-width='170',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.numeroContrato")',
            sortable
        )
        el-table-column(
            property='material',
            min-width='140',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.produto")',
            sortable
        )
        el-table-column(
            property='safraNome',
            min-width='140',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.colheita")'
        )
        el-table-column(
            property='volumeContratado',
            min-width='250',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeContratado")',
            sortable
        )
        el-table-column(
            property='dataContrato',
            min-width='200',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataContrato")',
            sortable
        )
        el-table-column(
            property='nomeVendedor',
            min-width='140',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.vendedor")'
        )
        el-table-column(
            property='cuitVendedor',
            min-width='140',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.cuitVendedor")',
            sortable
        )
        el-table-column(width='60', label='')
            template(slot-scope='scope')
                el-dropdown.action-button(trigger='click')
                    span.el-dropdown-link
                        i.mdi.mdi-dots-vertical
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-view',
                            @click.native='visualizarProcessamento(scope.row.numeroContrato)'
                        )
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.visualizarContrato') }}
                        el-dropdown-item(
                            @click.native='editarContrato(scope.row.numeroContrato)'
                        )
                            i.mdi.mdi-square-edit-outline
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.editarContrato') }}
                        el-dropdown-item(
                            v-if='false',
                            @click.native='arquivarContrato(scope.row.id)'
                        )
                            i.mdi.mdi-archive
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.arquivar') }}
</template>

<script>
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa.js';

export default {
    name: 'EmpresaTabelaInserirContratoAR',
    props: {
        contratosNaoEnviados: {
            type: Array,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        removendo: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            contratosSelecionados: []
        };
    },
    methods: {
        async arquivarContrato(idContratoOriginacao) {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.confirmarArquivamentoContrato'
                ),
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                try {
                    const idsContratosOriginacao = [idContratoOriginacao];
                    await ContratoOriginacaoServiceEmpresa.arquivarContrato(
                        idsContratosOriginacao
                    );
                    this.$notify.success(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratoArquivado'
                        )
                    );
                    this.buscarTotalizadores();
                    this.buscarContratosEmpresa();
                } catch (error) {
                    this.$notify.error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroArquivarContrato'
                        )
                    );
                }
            }
        },
        visualizarProcessamento(numeroContrato) {
            this.$router.push({
                name: 'VisualizarContratoOriginacaoEmpresaAR',
                params: { id: numeroContrato }
            });
        },
        editarContrato(numeroContrato) {
            this.$router.push({
                name: 'EditarContratoOriginacaoEmpresaAR',
                params: { id: numeroContrato }
            });
        },
        emiteRemoverContratoLote(idsContratosOriginacao) {
            this.$emit('contratosSelecionados', idsContratosOriginacao);
        },
        ordenarContratos({ order, prop }) {
            const ordem = order === 'ascending' ? 'asc' : 'desc';
            const coluna = this.colunaOrdenacao[prop]();
            this.$emit('ordenar', `${coluna},${ordem}`);
        },
        async handleSelectionChange(dadosContrato) {
            this.contratosSelecionados = dadosContrato;
            const idsContratosOriginacao = this.contratosSelecionados.map(
                contrato => contrato.id
            );

            this.emiteRemoverContratoLote(idsContratosOriginacao);
        }
    }
};
</script>

<style lang="scss">
#empresa-tabela-inserir-contrato-originacao-ar {
    .el-table th.el-table__cell > .cell {
        font-family: Roboto;
        font-weight: 500;
        font-size: 16px;
    }
    .el-table td.el-table__cell div {
        font-family: Roboto;
        font-weight: 400;
        font-size: 14px;
    }
    .el-checkbox__inner {
        border: 1.5px solid #3b3b3b;
    }
    button {
        width: 12px;
        background: transparent;
        border: 0;
        color: #3b3b3b;
        cursor: pointer;
        &:focus {
            outline: 0;
        }
    }
}
</style>
